import React from 'react';

class Col extends React.Component {
    constructor(props) {
        super(props);
        this.state = { }
    }

    createComponentClasses() {
        let {
            xl,
            lg,
            md,
            sm,
            className
        } = this.props;

        let classNames = ['col'];
        if (sm)             classNames.push(`_s${sm}`);
        if (md)             classNames.push(`_m${md}`);
        if (lg)             classNames.push(`_l${lg}`);
        if (xl)             classNames.push(`_xl${xl}`);
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render() {
        let { children } = this.props;
        return (
            <div className={ this.createComponentClasses() }>
                { children }
            </div>
        )
    }
}

export default Col;